module.exports = __webpack_public_path__ + "img/1557614067924934659.6afef640.png";